import { BrandIdentityGuideSchema } from "@redotech/redo-agents-common/aeo-agents/brand-identity-guide";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getAdminBrandIdentityGuide = unaryRpc({
  name: "getAdminBrandIdentityGuide",
  input: z.object({ teamId: zExt.objectId() }),
  output: BrandIdentityGuideSchema.nullable(),
});
